import { numToValuta } from "~/script";

export default [
	{
		stat: "clicks",
		title: "Clicks",
		desc: "The number of times you have clicked to earn money.",
	},
	{
		stat: "earnings_from_clicks",
		title: "Earnings from clicks",
		desc: "The amount of money you have earned from clicking.",
		unit: "money",
	},
	{
		stat: "xp_from_clicks",
		title: "Experience from clicks",
		desc: "The amount of XP you have earned from clicking.",
		unit: "xp",
	},
	{
		stat: "time_played",
		title: "Time Played",
		desc: "The amount of time you have spend.",
		unit: "time-seconds",
	},
	{
		stat: "opened_cases",
		title: "Opened Cases",
		desc: "The number of cases you have opened.",
	},
	{
		stat: "opened_capsules",
		title: "Opened Sticker Capsules",
		desc: "The number of capsules you have opened.",
	},
	{
		stat: "opened_rarities_2",
		title: "Opened Milspec",
		desc: 'The number of "milspec" rarity skins and stickers you have opened.',
	},
	{
		stat: "opened_rarities_3",
		title: "Opened Restricted",
		desc: 'The number of "restricted" rarity skins and stickers you have opened.',
	},
	{
		stat: "opened_rarities_4",
		title: "Opened Classified",
		desc: 'The number of "classified" rarity skins and stickers you have opened.',
	},
	{
		stat: "opened_rarities_5",
		title: "Opened Covert",
		desc: 'The number of "covert" rarity skins and stickers you have opened.',
	},
	{
		stat: "opened_rarities_6",
		title: "Opened Exceedingly Rare",
		desc: "The number of exceedingly rare skins and stickers you have opened.",
	},
	{
		stat: "skin_sold",
		title: "Items Sold",
		desc: "The number of items you have sold.",
	},
	{
		stat: "earnings_from_skin_sales",
		title: "Earnings From Skin Sales",
		desc: "The amount of money you have earned selling skins.",
		unit: "money",
	},
	{
		stat: "skin_sold_gt10",
		title: `Skins Sold > ${numToValuta(1e3, 2)}`,
		desc: `The number of items you have sold, where each was worth more than ${numToValuta(1e3, 2)}.`,
	},
	{
		stat: "skin_sold_gt50",
		title: `Skins Sold > ${numToValuta(5e3, 2)}`,
		desc: `The number of items you have sold, where each was worth more than ${numToValuta(5e3, 2)}.`,
	},
	{
		stat: "skin_sold_gt250",
		title: `Skins Sold > ${numToValuta(25e3, 2)}`,
		desc: `The number of items you have sold, where each was worth more than ${numToValuta(25e3, 2)}.`,
	},
	{
		stat: "skin_sold_r2",
		title: "Skins Sold with Milspec rarity",
		desc: 'The number of items you have sold with "milspec" rarity.',
	},
	{
		stat: "skin_sold_r3",
		title: "Skins Sold with Restricted rarity",
		desc: 'The number of items you have sold with "restricted" rarity.',
	},
	{
		stat: "skin_sold_r4",
		title: "Skins Sold with Classified rarity",
		desc: 'The number of items you have sold with "classified" rarity.',
	},
	{
		stat: "skin_sold_r5",
		title: "Skins Sold with Covert rarity",
		desc: 'The number of items you have sold with "covert" rarity.',
	},
	{
		stat: "skin_sold_r6",
		title: "Skins Sold with Exceedingly Rare rarity",
		desc: "The number of exceedingly rare skins you have sold.",
	},
	{
		stat: "total_coinflips",
		title: "Coinflips Played",
		desc: "The number of coinflips you have played.",
	},
	{
		stat: "total_coinflips_won",
		title: "Coinflips Won",
		desc: "The number of coinflips you have won.",
	},
	{
		stat: "total_coinflips_lost",
		title: "Coinflips Lost",
		desc: "The number of coinflips you have lost.",
	},
	{
		stat: "win_jackpot",
		title: "Jackpots Won",
		desc: "The number of jackpots you have won.",
	},
	{
		stat: "lose_jackpot",
		title: "Jackpots Lost",
		desc: "The number of jackpots you have lost.",
	},
	{
		stat: "total_winnings",
		title: "Winnings from Coinflip and Jackpot",
		desc: "The total amount of money (in skin value) you have won from coinflip and jackpot.",
		unit: "money",
	},
	{
		stat: "total_lucky_wheel_spins",
		title: "Lucky Wheel Spins",
		desc: "The number of times you have spun the lucky wheel.",
	},
	{
		stat: "tree_upgrades_purchased",
		title: "Purchased Upgrades",
		desc: "The number of upgrades you have purchased this prestige.",
	},
	{
		stat: "total_tree_upgrades_purchased",
		title: "Total Upgrades Bought",
		desc: "The number of upgrades you have purchased across all prestiges.",
	},
	{
		stat: "missions_finished",
		title: "Missions Finished",
		desc: "The number of missions you have completed.",
	},
	{
		stat: "earnings_from_missions",
		title: "Earnings from Missions",
		desc: "Total amount of money you have earned from completing missions.",
		unit: "money",
	},
	{
		stat: "xp_from_missions",
		title: "XP from Missions",
		desc: "The amount of xp you have earned from completing missions.",
		unit: "xp",
	},
	{
		stat: "items_discovered",
		title: "Items Discovered",
		desc: "The number of items you have discovered.",
	},
	{
		stat: "skins_discovered",
		title: "Skins Discovered",
		desc: "The number of skins you have discovered.",
	},
	{
		stat: "stickers_discovered",
		title: "Stickers Discovered",
		desc: "The number of stickers you have discovered.",
	},
	{
		stat: "tradeups",
		title: "Trade Up Contracts",
		desc: "The number of times you have done a trade up contract.",
	},
	{
		stat: "save_times_imported",
		title: "Save Imports",
		desc: "The amount of times you have imported this save.",
	},
	{
		stat: "achievements_completed",
		title: "Achievements Completed",
		desc: "The amount of achievements you have completed.",
	},
	{
		stat: "earnings_from_achievements",
		title: "Earnings from Achievements",
		desc: "Total amount of money you have earned from completing achievements.",
		unit: "money",
	},
	{
		stat: "xp_from_achievements",
		title: "XP from Achievements",
		desc: "The amount of xp you have earned from completing achievements.",
		unit: "xp",
	},
	{
		stat: "earned_passive",
		title: "Passively earned money",
		desc: "The amount of money you have earned passively.",
		unit: "money",
	},
	{
		stat: "earned_offline",
		title: "Offline earned money",
		desc: "The amount of money you have earned while not playing.",
		unit: "money",
	},
	{
		stat: "withdrawn_from_chips",
		title: "Cash withdrawn with chips",
		desc: "The amount of cash you have withdrawn with chips.",
	},
	{
		stat: "skins_tradein_amount",
		title: "Skins traded in",
		desc: "The amount of skins you have traded in at the casino.",
	},
	{
		stat: "skins_tradein",
		title: "Value of skins traded in",
		desc: "Total cash value of the skins you have traded in at the casino.",
		unit: "money",
	},
	{
		stat: "daily_missions_finished",
		title: "Daily Missions Completed",
		desc: "The total amount of Daily Missions you have completed",
	},
	{
		stat: "daily_missions_streak",
		title: "Daily Missions Streak",
		desc: "Your longest Daily Missions completion streak",
	},
	{
		stat: "prestige_times",
		title: "Prestige",
		desc: "Your total amount of prestiges",
	},
] as const;
